@if(loading){
<mat-spinner style="margin:auto;"></mat-spinner>
}@else{
<h1> Select Remote Access Method</h1>
@if(ips==null || ((ips.StandardCheckInIPs==null ||
ips.StandardCheckInIPs.length==0)&&(ips.VpnIp==""||ips.VpnIp==null))){
<p> No IP addresses available for this device. </p>
}@else{
@if(!controlsLoading){
<div class="ip-list">
    @if(ips.VpnIp!=null && ips.VpnIp!=""){
    <div class="ip-entry">
        <p class="ip">VPN IP: {{ips.VpnIp}}</p>
        <div class="buttons">
            <button mat-raised-button type="button" (click)="openHTTP(ips.VpnIp);"><span
                    class="material-icons">web</span>
                HTTP</button>
            <button mat-raised-button class="padded-btn" type="button" (click)="openSSH(ips.VpnIp);"><span
                    class="material-icons">key</span>
                SSH</button>
        </div>
    </div>
    }
    @for(ip of ips.StandardCheckInIPs; track ip){
    <div class="ip-entry">
        <p class="ip">IP: {{ip}}</p>
        <div class="buttons">
            <button mat-raised-button type="button" (click)="openHTTP(ip);"><span class="material-icons">web</span>
                HTTP</button>
            <button mat-raised-button class="padded-btn" type="button" (click)="openSSH(ip);"><span
                    class="material-icons">key</span>
                SSH</button>
        </div>
    </div>
    }
</div>
}@else {
<div class="spinner-wrapper">
    <mat-spinner style="margin:auto; padding-bottom: 5px;"></mat-spinner>
</div>
}
@if(displayTerminal){
<div class="terminal-container">
    <div class="terminal-class" #myTerminal></div>
</div>
}@else if(terminalLoading){
<div class="spinner-wrapper">
    <mat-spinner style="margin:auto;"></mat-spinner>
</div>
}
}

}